import { SETID, DECREMENT_COUNTER, INCREMENT_COUNTER, STEP5, } from '../actions/counterActions';

const counterReducer = (state = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    requestId: '',
    value: 0,
    master: 1,
    step5: {
        taskIstanceIdStep5: 0,
        processIstanceIdStep5: 0,
        step: 5,
        step5Validate: false,
        step5Data: {
            prvDoc: [],
            recComment: '',
        }
    },




}, action) => {
    switch (action.type) {
        case SETID:
            return { ...state, requestId: action.payload.requestId }

        case INCREMENT_COUNTER:
            return { ...state, value: state.value + 1 };
        case DECREMENT_COUNTER:
            return { ...state, value: state.value - 1 };


        case STEP5:
            return {
                ...state, master: action.payload.step, currentValidate: false, step5: {
                    taskIstanceIdStep5: action.payload.taskIstanceIdStep5,
                    processIstanceIdStep5: action.payload.processIstanceIdStep5,
                    step: action.payload.step,
                    step5Validate: true,
                    step5Data: {
                        prvDoc: action.payload.step5Data.prvDoc,
                        recComment: action.payload.step5Data.recComment,
                    }
                }
            };


        default:
            return { ...state };
    }
};

export default counterReducer;
